export default __webpack_public_path__ + "static/simple-pie-837f4382bfc7704ec3d9669b75774bde.png";